import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import PublicLayout from "@/components/public/PublicLayout";

export default function Categories() {
  const [cats, setCats] = useState([]);
  useEffect(() => { api.get("/public/categories").then((r) => setCats(r.data)).catch(() => {}); }, []);
  return (
    <PublicLayout>
      <div className="mx-auto max-w-7xl px-6 py-10">
        <h1 className="font-display text-3xl font-bold tracking-tight lg:text-4xl">Categories</h1>
        <p className="mt-1 text-muted-foreground">Shop by category on easy installments.</p>
        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {cats.map((c) => (
            <Link key={c.id} to={`/products?category=${c.slug}`} data-testid={`cat-card-${c.slug}`}
              className="group relative overflow-hidden rounded-2xl border border-border">
              <img src={c.image} alt={c.name} className="h-52 w-full object-cover transition-transform duration-500 group-hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-transparent" />
              <div className="absolute bottom-0 p-5 text-white">
                <h3 className="font-display text-xl font-bold">{c.name}</h3>
                <p className="text-sm text-white/80">{c.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </PublicLayout>
  );
}
